var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-header",
            [_c("b-card-title", [_vm._v("Inventory Movement Over Time")])],
            1
          ),
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "6", lg: "4" } },
                    [
                      _c("label", { staticClass: "font-weight-bold" }, [
                        _vm._v("Select Product"),
                      ]),
                      _c("b-form-select", {
                        attrs: { options: _vm.productOptions, size: "sm" },
                        on: { change: _vm.handleProductChange },
                        model: {
                          value: _vm.selectedProductId,
                          callback: function ($$v) {
                            _vm.selectedProductId = $$v
                          },
                          expression: "selectedProductId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isLocalLoading
                ? _c(
                    "div",
                    { staticClass: "d-flex justify-content-center my-4" },
                    [
                      _c("b-spinner", {
                        attrs: { variant: "primary", label: "Loading..." },
                      }),
                    ],
                    1
                  )
                : _vm.chartData.length > 0
                ? _c(
                    "div",
                    [
                      _c("apexchart", {
                        attrs: {
                          type: "line",
                          height: _vm.chartOptions.chart.height,
                          options: _vm.chartOptions,
                          series: _vm.series,
                        },
                      }),
                    ],
                    1
                  )
                : _c("div", { staticClass: "text-center py-5" }, [
                    _c("i", {
                      staticClass: "fas fa-chart-line text-muted mb-3",
                      staticStyle: { "font-size": "3rem" },
                    }),
                    _c("h4", { staticClass: "text-muted" }, [
                      _vm._v("No Inventory Movement Data Available"),
                    ]),
                    _c("p", [
                      _vm._v(
                        "There is no inventory movement data for the selected product and date range."
                      ),
                    ]),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }